import PropTypes from "prop-types";
import { useEffect, useState, useRef } from "react";
import useImageWrapper from "helpers/hooks/useImageWrapper";
import Carousel from "components/shared/stays/Carousel";
import Title from "components/shared/stays/Title";
import Truncate from "solar/components/Truncate";
import Text from "components/shared/stays/Text";
import Photo from "components/shared/stays/Photo";
import ButtonImage from "solar/components/ButtonImage";
import styles from "components/stay/Products.module.scss";
import ProductsModal from "./ProductsModal";

export default function Products({ products, tripTypeDescription }) {
  const visibleProducts = products.filter((p) => p.is_visible);
  const [activeProduct, setActiveProduct] = useState("");
  const [showModal, setShowModal] = useState(false);
  const handleModalClose = () => setShowModal(false);
  const { getImageWidth } = useImageWrapper();
  const [imgWidths, setImgWidths] = useState([0]);
  const imgWrapperRef = useRef(null);

  useEffect(() => {
    const calculatedWidth = getImageWidth([imgWrapperRef]);
    setImgWidths(calculatedWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleModalShow(i) {
    setShowModal(true);
    setActiveProduct(i);
  }

  return (
    <div className={styles.component}>
      <Carousel
        title={
          <Title>{tripTypeDescription === "Boat" ? "Routes" : "Rooms"}</Title>
        }
      >
        {visibleProducts.map((product) => (
          <div key={product.id}>
            <div className={styles.visual} ref={imgWrapperRef}>
              {product.product_images.length > 0 && (
                <ButtonImage
                  onClick={() => handleModalShow(product.id)}
                  className={styles.button}
                >
                  <Photo
                    src={product.product_images[0].file.url}
                    alt={product.name}
                    layout="fill"
                    objectFit="cover"
                    placeholder
                    containerWidth={imgWidths[0]}
                  />
                </ButtonImage>
              )}
            </div>
            <div className={styles.text}>
              <div className={styles.name}>{product.name}</div>
              <div className={styles.description}>
                <Truncate clamp={2}>
                  <Text>{product.description}</Text>
                </Truncate>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
      <ProductsModal
        visibleProducts={visibleProducts}
        showModal={showModal}
        activeProduct={activeProduct}
        setActiveProduct={setActiveProduct}
        handleModalClose={handleModalClose}
        tripTypeDescription={tripTypeDescription}
      />
    </div>
  );
}

Products.propTypes = {
  tripTypeDescription: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      price: PropTypes.string,
      product_images: PropTypes.arrayOf(
        PropTypes.shape({
          file: PropTypes.shape({
            url: PropTypes.string,
          }),
        })
      ),
      direction: PropTypes.string,
      type: PropTypes.string,
      description: PropTypes.string,
    })
  ).isRequired,
};
